// ---------------------------------------------------------------------------
// Section 7: Border — radius, width, color, style
// ---------------------------------------------------------------------------

import { InspectorSection } from '@/components/inspector'
import {
  InlineSelectField,
  InlineColorField,
  ROUNDED_OPTIONS,
  BORDER_WIDTH_OPTIONS,
  BORDER_STYLE_OPTIONS,
} from '../fields'
import {
  extractRounded,
  setRounded,
  extractBorderWidth,
  setBorderWidth,
  extractBorderColor,
  setBorderColor,
  extractBorderStyle,
  setBorderStyle,
} from '@/features/page-editor/lib/class-utils'
import type { CogoElement } from '@/features/page-editor/store/types'

export function BorderSection({
  element,
  updateClass,
}: {
  element: CogoElement
  updateClass: (transform: (cls: string) => string) => void
}) {
  const cls = element.className ?? ''

  // Auto-collapse if no border values are set
  const hasValues = !!(extractRounded(cls) || extractBorderWidth(cls) || extractBorderColor(cls) || extractBorderStyle(cls))

  return (
    <InspectorSection title="Border" defaultOpen={hasValues}>
      {/* Border Radius */}
      <InlineSelectField
        label="Radius"
        value={extractRounded(cls)}
        onChange={(val) => updateClass((c) => setRounded(c, val))}
        options={ROUNDED_OPTIONS}
        show
      />

      {/* Border Width */}
      <InlineSelectField
        label="Width"
        value={extractBorderWidth(cls)}
        onChange={(val) => updateClass((c) => setBorderWidth(c, val))}
        options={BORDER_WIDTH_OPTIONS}
        show
      />

      {/* Border Color */}
      <InlineColorField
        label="Color"
        value={extractBorderColor(cls)}
        onChange={(color) => updateClass((c) => setBorderColor(c, color))}
        testId="color-border"
      />

      {/* Border Style */}
      <InlineSelectField
        label="Style"
        value={extractBorderStyle(cls)}
        onChange={(val) => updateClass((c) => setBorderStyle(c, val))}
        options={BORDER_STYLE_OPTIONS}
        show
      />
    </InspectorSection>
  )
}
